import { IncidentComment, Severity } from './Incident';

export class Range {
  start: number;
  end: number;

  constructor(start: number, end: number) {
    this.start = start;
    this.end = end;
  }

  toString(): string {
    return `[${this.start}, ${this.end}]`;
  }

  length(): number {
    return this.end - this.start;
  }

  /**
   * transfers this range from domain to codomain
   */
  transform(domain: Range, codomain: Range): Range {
    const scaledStart = domain.transformPoint(this.start, codomain);
    const scaledEnd = domain.transformPoint(this.end, codomain);
    return new Range(scaledStart, scaledEnd);
  }

  /**
   * transforms a point in domain defined by this range to specified codomain
   */
  transformPoint(x: number, codomain: Range): number {
    const scaleFactor = codomain.length() / this.length();
    return (x - this.start) * scaleFactor + codomain.start;
  }
}

export class Period {
  start: Date;
  end: Date;

  constructor(start: Date | string | number, end: Date | string | number) {
    this.start = new Date(start);
    this.end = new Date(end);
  }

  trunc(start: Date | number, end: Date | number): Period {
    const result = new Period(this.start, this.end);
    if (start > result.start) {
      result.start = new Date(start);
    }
    if (end < result.end) {
      result.end = new Date(end);
    }
    return result;
  }

  asRange(): Range {
    return new Range(this.start.getTime(), this.end.getTime());
  }
}

export class ComponentDowntime {
  name: string;
  severity: Severity;
  downtime: Period;
  details: IncidentComment[];
  title: string;
  originalEnd: Date;

  constructor(
    name: string,
    severity: Severity,
    downtime: Period,
    details: IncidentComment[],
    title: string,
    originalEnd: Date
  ) {
    this.name = name;
    this.severity = severity;
    this.downtime = downtime;
    this.details = details;
    this.title = title;
    this.originalEnd = originalEnd;
  }
}
